import { defineComponent, SetupContext, ref, PropType } from 'vue'
    import useStore from '@/hooks/useStore'
    import { Message } from '@/types/message'
    import { searchMessageOnReply } from '@/store/reply'
    import useMessage from '@/hooks/useMessage'
    import { formatMessage } from '@/helpers/messages'

    import MessageInteract from '@/components/Message/MessageInteract.vue'
    import ReplyHome from '../Reply/ReplyHome.vue'
    import MessageHour from '@/components/Message/MessageHour.vue'

    export default defineComponent({
        emits: ['onClick'],

        components: {
            MessageHour,
            MessageInteract,
            ReplyHome
        },

        props: {
            modelValue: {
                type: Object as PropType<Message>,
                default: () => ({})
            }
        },

        setup (props, { emit }: SetupContext) {
            const state = ref<Message>(props.modelValue)
            const onFocus = ref<boolean>(false)
            const replyId = state.value?.reply?.message_id ?? null
            const store = useStore()
            const color = store.data.bgColor

            function handleClickInteract (id: string): void {
                if (searchMessageOnReply(id)) {
                    onFocus.value = !onFocus.value
                }
            }

            const backgroundColor = useMessage().defineBackgroundColor(state.value.position)

            return {
                emit,
                onFocus,
                handleClickInteract,
                replyId,
                color,
                state,
                backgroundColor,
                formatMessage
            }
        }
    })
